import React from 'react';
import PropTypes from 'prop-types';
import { Sidebar, Transition } from 'semantic-ui-react';
import { RootConsumer } from '../../RootComponent';

const Drawer = ({ children, onHide, style, visible }) => (
  <React.Fragment>
    <Transition visible={visible} animation='fade' duration={200}>
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.8)',
          zIndex: 1
        }}
      />
    </Transition>
    <RootConsumer>
      {({ isMobile }) =>
        <Sidebar
          animation='overlay'
          onHide={onHide}
          direction='right'
          visible={visible}
          style={Object.assign({
            width: isMobile ? '100%' : '80%',
            height: '100%',
            background: 'white',
            boxShadow: '0px 0px 20px rgba(0,0,0,0.5)'
          }, style || {})}
        >
          {children}
        </Sidebar>}
    </RootConsumer>
  </React.Fragment>
);

const Content = ({ children }) => (
  <RootConsumer>
    {({ isMobile }) => (
      <div style={{ padding: isMobile ? '1em' : '2em', flex: 1 }}>
        {children}
      </div>
    )}
  </RootConsumer>
);

const Footer = ({ children, style }) => (
  <div
    style={Object.assign({
      borderTop: '1px solid rgba(34,36,38,.15)',
      textAlign: 'right',
      position: 'sticky',
      bottom: 0,
      left: 0,
      width: '100%',
      padding: '1em',
      background: '#f9fafb',
      zIndex: 1
    }, style || {})}
  >
    {children}
  </div>
);

Drawer.propTypes = {
  children: PropTypes.node.isRequired,
  onHide: PropTypes.func,
  style: PropTypes.object,
  visible: PropTypes.bool
};

Content.propTypes = {
  children: PropTypes.node.isRequired
};

Footer.propTypes = {
  children: PropTypes.node.isRequired,
  style: PropTypes.object
};

Drawer.Content = Content;
Drawer.Footer = Footer;

export default Drawer;



// WEBPACK FOOTER //
// ./webpack/components/Modules/Drawer/Drawer.js